module.exports = __webpack_public_path__ + "img/nextspin.c55d91b3.jpg";